import {
  useCreateNewCompanyAndAdmin,
  useRejectRegister,
} from "@/common/api/mutation";
import { useGetRegisterData } from "@/common/api/queries";
import { customerCurrency } from "@/common/const/filter-options";
import { adminFormCreate, companyCreateNewStrategy } from "@/common/strategies";
import { RegisterCompanyData } from "@/common/types";
import { MainHeader } from "@/components";
import Typography from "@/components/Typography/Typography";
import { BaseForm } from "@/components/form";
import { Button, Form, Popconfirm } from "antd";
import { useForm } from "antd/es/form/Form";
import { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";

export default function CreateCustomerPage() {
  const params = useParams();
  const { data: signUpReq } = useGetRegisterData(
    params?.customerRegisterID || ""
  );
  const [form] = useForm();
  const { mutate } = useCreateNewCompanyAndAdmin();
  const navigate = useNavigate();
  const [popConfirm, setPopConfirm] = useState<boolean>(false);

  const onSubmit = ({
    accountType,
    billing_address,
    companyName,
    country,
    currency,
    designation,
    email,
    fullName,
    location,
    msa,
    nda,
    phoneNumber,
    registered_address,
    title,
    website,
  }: RegisterCompanyData) => {
    const companyInfo = {
      accountType: accountType,
      companyType: signUpReq?.companyType,
      billing_address,
      companyName,
      country,
      currency,
      msa,
      nda,
      website,
      registered_address,
    };
    const adminInfo = {
      designation,
      email,
      fullName,
      location,
      phoneNumber,
      title,
      roleID: signUpReq?.companyType === "vendor" ? 4 : 2,
    };
    const registerData = {
      companyInfo,
      adminInfo,
      signUpId: params?.customerRegisterID || "",
    };
    mutate(registerData, {
      onSuccess: (data: { companyId: number }) => {
        toast.success("New company created");
        if (signUpReq?.companyType === "vendor") {
          navigate(`/vendors/${data.companyId}`);
        }
        if (signUpReq?.companyType === "customer") {
          navigate(`/customers/${data.companyId}`);
        }
      },
    });
  };
  const mutateData = (data?: any): Record<string, any>[] => {
    if (typeof data === "undefined") return [];
    return [
      {
        companyName: data?.companyName,
        companyType: "carrier",
        registered_address: "",
        billing_address: "",
        country: "",
        currency: "USD",
        nda: "null",
        msa: "null",
        website: "",
      },
      {
        title: "Mr.",
        fullName: data.adminFullName,
        email: data.adminEmail,
        phoneNumber: data.adminphoneNumber,
        designation: "",
        location: "",
      },
    ];
  };

  const { mutate: rejectMutation } = useRejectRegister();

  const rejectCompanyCreation = () => {
    rejectMutation(params?.customerRegisterID || "", {
      onSuccess: () => {
        toast.success("Register request deleted");
        navigate("/notification");
      },
    });
  };
  const openConfirm = () => {
    setPopConfirm(true);
  };
  const strategy =
    signUpReq?.companyType === "vendor"
      ? companyCreateNewStrategy
      : companyCreateNewStrategy.map((el) => {
          if (el.name === "currency") {
            return { ...el, options: customerCurrency };
          }
          return el;
        });
  return (
    <>
      <MainHeader pageName="Register new company" />
      <div className="p-5">
        <Form form={form} onFinish={onSubmit} name="customer-register">
          <div className="flex flex-col gap-4">
            <div>
              <Typography
                mb={2}
                type="p"
                fontSize={18}
                lineHeight={7}
                fontWeight="font-medium"
                fontFamily="font-kanit"
              >
                Company Information
              </Typography>
              {!!signUpReq && (
                <BaseForm
                  key="company-form"
                  formStrategy={strategy}
                  data={
                    typeof signUpReq !== "undefined"
                      ? mutateData(signUpReq)[0]
                      : {}
                  }
                />
              )}
            </div>

            <div>
              <Typography
                mb={2}
                type="p"
                fontSize={18}
                lineHeight={7}
                fontWeight="font-medium"
                fontFamily="font-kanit"
              >
                Admin info
              </Typography>
              {!!signUpReq && (
                <BaseForm
                  key="admin-form"
                  formStrategy={adminFormCreate}
                  data={
                    typeof signUpReq !== "undefined"
                      ? mutateData(signUpReq)[1]
                      : {}
                  }
                />
              )}{" "}
            </div>
          </div>
          <div className="flex gap-4 mt-6">
            <Button
              htmlType="submit"
              type="primary"
              className=" py-[18px] h-auto"
            >
              <Typography
                type="span"
                fontFamily="font-inter"
                fontWeight="font-semibold"
                fontSize={14}
              >
                Create new company
              </Typography>
            </Button>
            <Popconfirm
              title="Delete this Request"
              description="Are you sure to delete this register request?"
              onConfirm={rejectCompanyCreation}
              trigger="click"
              okText="Yes"
              cancelText="No"
              open={popConfirm}
              onCancel={() => setPopConfirm(false)}
            >
              <button
                onClick={openConfirm}
                type="button"
                className="h-auto max-h-[58px] px-4 py-1 rounded-lg text-sm font-inter font-semibold transition bg-red-main text-red-light hover:bg-opacity-80 "
              >
                Reject register request
              </button>
            </Popconfirm>
          </div>
        </Form>
      </div>
    </>
  );
}
